const STICKY_CONTAINER_ID = 'sticky-container';

function isScrollableElement(element: HTMLElement): boolean {
    const style = window.getComputedStyle(element);
    const overflowY = style.overflowY;
    const overflow = style.overflow;

    return (
        overflowY === 'auto' ||
        overflowY === 'scroll' ||
        overflowY === 'overlay' ||
        overflow === 'auto' ||
        overflow === 'scroll'
    );
}

function getScrollParent(node: HTMLElement | null): Element | null {
    let current = node ? node.parentElement : null;

    while (current) {
        if (isScrollableElement(current as HTMLElement)) {
            return current;
        }

        current = current.parentElement;
    }

    return null;
}

export function getProductListScrollTarget(): Element | Window {
    const shell = document.getElementById(STICKY_CONTAINER_ID) as HTMLElement | null;

    if (shell && isScrollableElement(shell)) {
        return shell;
    }

    const scrollRoot = shell ? getScrollParent(shell) : null;

    if (
        scrollRoot &&
        scrollRoot !== document.documentElement &&
        scrollRoot !== document.body
    ) {
        return scrollRoot;
    }

    return window;
}

export function hasProductListScrollContainer(): boolean {
    return !!document.getElementById(STICKY_CONTAINER_ID);
}

function getScrollTarget(): Element | Window {
    return getProductListScrollTarget();
}

export function readProductListScrollTop(): number {
    const target = getScrollTarget();

    if (target === window) {
        return window.scrollY || document.documentElement.scrollTop || 0;
    }

    return (target as HTMLElement).scrollTop;
}

export function setProductListScrollTop(scrollTop: number): void {
    const target = getScrollTarget();

    if (target === window) {
        window.scrollTo({ top: scrollTop, behavior: 'auto' });
        return;
    }

    (target as HTMLElement).scrollTop = scrollTop;
}
